export default __webpack_public_path__ + "static/media/man1.9af36716.jpg";